import { FieldText, FlexBox, IconButton } from '@dixa/lib-shared-habla';
import { Field } from 'redux-form';

import styles from './headerRow.module.scss';

export const KEY_FIELD = 'key';
export const VALUE_FIELD = 'value';

interface Props {
  field: string;
  index: number;
  onRemove: (index: number) => void;
}

export function HeaderRow({ field, index, onRemove }: Props): JSX.Element {
  return (
    <FlexBox alignItems="center" justifyContent="space-between">
      <Field
        className={styles.field}
        component={FieldText}
        label="Key"
        name={`${field}.${KEY_FIELD}`}
        placeholder="Key"
        type="option"
      />
      <Field
        className={styles.field}
        component={FieldText}
        label="Value"
        name={`${field}.${VALUE_FIELD}`}
        placeholder="Value"
        type="option"
      />
      <IconButton
        className={styles.trash}
        icon="trash"
        onClick={() => onRemove(index)}
        variant="tertiary"
      />
    </FlexBox>
  );
}
